
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Route, Location } from 'vue-router';
import BDialog from '@/components/Dialog.vue';
import api from '@/api';
import Swal from 'sweetalert2';

const { store, member } = api;

@Component({
  components: {
    BDialog,
  },
})
export default class StoreAdminList extends Vue {
  @Prop() private merchantId!: number;

  @Prop() private storeId!: string;

  private loading: boolean = false;

  private selectedUser: { text: string; userId: number } | null = null;

  private search: string = '';

  private from: Route | null = null;

  private collection: [] = [];

  private searchResults: [] = [];

  private headers = [
    { text: 'ID', value: 'userId', width: 80 },
    { text: '外部ID', value: 'userIdPublic', width: 120 },
    { text: '姓名', value: 'fullName' },
    { text: '刪除', value: 'delete' },
  ];

  @Watch('search')
  private async searchWatcher(val: any) {
    this.loading = true;
    const {
      data: { data },
    } = await member.list({ pageNo: 1, pageSize: 10, q: val });
    this.loading = false;

    this.searchResults = data.map((i: any) => ({
      text: `${i.userIdPublic} ${i.fullName}`,
      userId: i.userId,
    }));
  }

  private async close() {
    const { merchantId, storeId } = this;
    if (!this.from?.name) {
      await this.$router.push({
        name: 'storeList',
        params: {
          merchantId: `${merchantId}`,
          storeId,
        },
      });
    }
    await this.$router.back();
  }

  private async append() {
    const { userId } = this.selectedUser!;
    if (!userId) return;
    this.loading = true;
    const { status } = await store.addAdmin(
      this.merchantId,
      this.storeId,
      userId,
    );
    if (status === 1) {
      this.selectedUser = null;
      await this.reload();
    }
    this.loading = false;
  }

  private async handleDelete(userId: number) {
    await Swal.fire({
      title: '您確定要刪除嗎?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: '確定',
      cancelButtonText: '取消',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const { status, message } = await store.deleteAdmin(
          this.merchantId,
          this.storeId,
          userId,
        );
        if (status === 1) {
          Swal.fire({ icon: 'success', title: '刪除成功' });
          await this.reload();
        } else {
          Swal.fire({ icon: 'error', title: message });
        }
      }
    });
  }

  private async reload() {
    const { data } = await store.listAdmins(this.merchantId, this.storeId);
    this.setData(data);
  }

  private setFromRoute(route: Route) {
    this.from = route;
  }

  private setData(users: []) {
    this.collection = users;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: StoreAdminList) => void) | boolean) => void,
  ) {
    const { data } = await store.listAdmins(
      to.params.merchantId,
      to.params.storeId,
    );
    await next(async (vm) => {
      vm.setData(data);
      vm.setFromRoute(from);
    });
  }
}
